import { MomentTime } from "app/components/Moment/Moment";
import EventPhase from "app/screens/EventsScreen/components/EventPhase/EventPhase";
import type { EventIncidentType } from "app/types/eventType";
import "../../IceHockeyPhase.scss";

export default function IceHockeyPhaseDeadBall(props: {
  eventIncidents: EventIncidentType[];
  eventPhase: string;
}) {
  const { eventIncidents, eventPhase } = props;
  return (
    <>
      <EventPhase eventIncident={props.eventIncidents[0]} />
      <MomentTime
        value={eventIncidents[0]["phaseStartDate"]}
        eventPhase={eventPhase}
        countDown
      />
    </>
  );
}
